/* eslint-disable @typescript-eslint/naming-convention */
import { AbstractControl, AsyncValidatorFn, FormControl, ValidationErrors } from '@angular/forms';
import { Observable, of, Subject, timer } from 'rxjs';
import { TeamService } from '../services/team_service';

export function ValidateTeamIdExist(teamService: TeamService): AsyncValidatorFn {
    let interval: any;
    const timeout = 500;

    return (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => new Promise(resolve => {
            if (interval) {
                clearTimeout(interval);
            }

            interval = setTimeout(() => {
                teamService.getTeamProfile(control.value)
                    .then(team => {
                        resolve(team && team.id ? {teamExist: true} : null );
                    })
                    .catch(() => {
                        resolve(null);
                    });
            }, timeout > 0 ? timeout : 1000);
        });
}
